const isSafari = () => {
    return /(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent);
}

module.exports = {
    isSafari
}